import * as BABYLON from '@babylonjs/core';

const dragDistThreshold = 5;

class StarFieldInput {
    pointerIsDown = false;
    pointerDownLocation = undefined;

    tabKeyDown = false;

    constructor(scene, { onClickLambda, onTabKeyLambda }) {
        this.scene = scene;
        this.onClickLambda = onClickLambda;
        this.onTabKeyLambda = onTabKeyLambda;
    }

    onPointerObservable(pointerInfo) {
        switch (pointerInfo.type) {
            case BABYLON.PointerEventTypes.POINTERDOWN:
                this.onPointerDown(pointerInfo);
                break;
            case BABYLON.PointerEventTypes.POINTERUP:
                this.onPointerUp(pointerInfo);
                break;
            case BABYLON.PointerEventTypes.POINTERMOVE:
                this.onPointerMove(pointerInfo);
                break;
        }
    }

    onKeyboardObservable(kbInfo) {
        switch (kbInfo.type) {
            case BABYLON.KeyboardEventTypes.KEYDOWN:
                this.onKeyDown(kbInfo.event.key);
                break;
            case BABYLON.KeyboardEventTypes.KEYUP:
                this.onKeyUp(kbInfo.event.key);
                break;
        }
    }


    onPointerDown(pointerInfo) {
        if (this.pointerIsDown) return; //Protect against double events

        this.pointerIsDown = true;
        this.pointerDownLocation = { x: this.scene.pointerX, y: this.scene.pointerY }
    }

    onPointerUp(pointerInfo) {
        if (!this.pointerIsDown) return; //Protect against double events

        this.pointerIsDown = false;
        if (!this.#didDragSincePointerDown()) {
            if (this.onClickLambda) this.onClickLambda();
        }
    }

    onKeyDown(key) {
        if (key == "Tab") {
            if (this.tabKeyDown) return;
            this.tabKeyDown = true;
            if(this.onTabKeyLambda) this.onTabKeyLambda();
        }
    }

    onKeyUp(key) {
        if (key == "Tab") {
            if (!this.tabKeyDown) return;
            this.tabKeyDown = false;
        }
    }

    #didDragSincePointerDown() {
        const dx = this.scene.pointerX - this.pointerDownLocation.x;
        const dy = this.scene.pointerY - this.pointerDownLocation.y;
        const dist = Math.sqrt(dx * dx + dy * dy);
        return dist >= dragDistThreshold;
    }

    onPointerMove(pointerInfo) {

    }
}

export default StarFieldInput;